import { c as _c } from "react/compiler-runtime";
import { cn } from '@repo/ui';
import React, { type PropsWithChildren } from 'react';
import { getMorphoChainSlug } from '../utils/chain.utils';
type MorphoLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  chainId: number;
  marketId: string;
} & PropsWithChildren;
export function MorphoLink(props) {
  const $ = _c(15);
  let chainId;
  let children;
  let className;
  let marketId;
  let rest;
  if ($[0] !== props) {
    ({
      marketId,
      chainId,
      className,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = chainId;
    $[2] = children;
    $[3] = className;
    $[4] = marketId;
    $[5] = rest;
  } else {
    chainId = $[1];
    children = $[2];
    className = $[3];
    marketId = $[4];
    rest = $[5];
  }
  let t0;
  if ($[6] !== className) {
    t0 = cn(className, "hover:underline");
    $[6] = className;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] !== chainId) {
    t1 = getMorphoChainSlug(chainId);
    $[8] = chainId;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const t2 = `https://app.morpho.org/${t1}/market/${marketId}`;
  let t3;
  if ($[10] !== children || $[11] !== rest || $[12] !== t0 || $[13] !== t2) {
    t3 = <a target="_blank" className={t0} aria-label="Link to the Morpho app for this market" rel="noopener noreferrer" href={t2} {...rest}>{children}</a>;
    $[10] = children;
    $[11] = rest;
    $[12] = t0;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}